export default __webpack_public_path__ + "static/media/move.f77f7362.svg";